import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { loadMasterData } from "../utils/loadMasterData";

import { Editor } from '@tinymce/tinymce-react';

import PfTitle from "./PfTitle";
import PfTags from "./PfTags";

import PfEntity from "./PfEntity";
import PfRoadmap from "./PfRoadmap";
import PfEquity from "./PfEquity";
import PfFunding from "./PfFunding";


export default function ProjectForm() {

const [roadmapDirty, setRoadmapDirty] = useState(false);

  const [activeTab, setActiveTab] = useState("description");

  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    title_image: "",
    description: "",
    video_link: "",
    primary_image: "",
  });

  const [images, setImages] = useState({
    title_image: null,
    image1: null,
    image2: null,
    image3: null,
    image4: null,
    image5: null,
  });


  const [previews, setPreviews] = useState({});
  const [deleted, setDeleted] = useState({});
  const [videoFile, setVideoFile] = useState(null);



const editorRef = useRef(null);

  // Load project if editing
  useEffect(() => {
    if (!id) return;
    fetch(`${process.env.REACT_APP_API_BASE_URL}/projects`)
      .then((res) => res.json())
      .then((data) => {
        const project = (data.lists || []).find((p) => String(p.id) === String(id));
        if (project) {
          setForm({
            description: project.description,
            project_stage: project.project_stage,
            funding_stage: project.funding_stage,
            industry_stage: project.industry_stage || "",
            technology: project.technology || "",
            category: project.category,
            client: project.client,
            video_link: project.video_link || "",
            primary_image: project.primary_image || "",
          });

          const imgState = {};
          const previewState = {};

          if (project.title_image) previewState.title_image = project.title_image;
          if (project.images) {
            Object.entries(project.images).forEach(([key, url]) => {
              imgState[key] = null;
              previewState[key] = url;
            });
          }

          setImages((prev) => ({ ...prev, ...imgState }));
          setPreviews(previewState);
        }
         

setFundingRounds(
  project.funding_rounds && Array.isArray(project.funding_rounds)
    ? project.funding_rounds
    : []
);

      });
  }, [id]);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleImageChange = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setImages((prev) => ({ ...prev, [key]: file }));
      setPreviews((prev) => ({ ...prev, [key]: URL.createObjectURL(file) }));
      setDeleted((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handleDeleteImage = (key) => {
    setPreviews((prev) => ({ ...prev, [key]: null }));
    setImages((prev) => ({ ...prev, [key]: null }));
    setDeleted((prev) => ({ ...prev, [key]: true }));
  };

  const handlePrimaryChange = (key) =>
    setForm((prev) => ({ ...prev, primary_image: key }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const fd = new FormData();
// ✅ Save description from TinyMCE correctly
  const descriptionHTML = editorRef.current?.getContent() || "";
  fd.append("description", descriptionHTML);

  // ✅ Append all other fields except description
  Object.entries(form).forEach(([k, v]) => {
    if (k !== "description") fd.append(k, v);
  });


    if (id) fd.append("id", id);

    if (deleted.title_image) fd.append("delete_title_image", "1");
    if (images.title_image) fd.append("title_image", images.title_image);

    for (let i = 1; i <= 5; i++) {
      const key = `image${i}`;
      if (deleted[key]) fd.append(`delete_${key}`, "1");
      if (images[key]) fd.append(key, images[key]);
    }

    if (videoFile) fd.append("video", videoFile);

    const endpoint = id ? "updateProject" : "addProject";

 fd.append("funding_rounds", JSON.stringify(fundingRounds));

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/${endpoint}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}` },
        body: fd,
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { error: text };
      }

      if (data.success) {
        alert("✅ Project saved successfully!");
        //navigate("/projects");
      } else {
        console.error("Save failed:", data);
        alert("❌ " + (data.error || "Save failed"));
      }
    } catch (err) {
      console.error(err);
      alert("❌ Network error");
    } finally {
      setLoading(false);
    }
  };

  const imageCount = Object.values(previews).filter((x) => x).length;

  // 🔹 Nice upload icon component
  const UploadIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
      viewBox="0 0 24 24"
      stroke="gray"
      strokeWidth={1.8}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12" />
    </svg>
  );

  const calculateEndDate = (start, days) => {
  if (!start || !days) return "";
  const d = new Date(start);
  d.setDate(d.getDate() + Number(days));
  return d.toISOString().split("T")[0];
};


  const fundingRoundOptions = [
  "Equity",
  "Angel",
  "Pre-Seed",
  "Seed",
  "Bridge",
  "Series",
  "Venture Debt",
  "IPO"
];

const [fundingRounds, setFundingRounds] = useState([
  {
    round_number: "",
    round_name: "",
    series: "",
    amount_raised: "",
    amount_target: "",
    valuation: "",
    round_start_date: "",
    round_days: "",
    round_end_date: "",
    status: ""
  }
]);


const addFundingRound = () => {
  setFundingRounds([
    ...fundingRounds,
    { 
      round_name: "", 
      amount_raised: "", 
      amount_target: "", 
      valuation: "",
      round_start_date: "",
      round_days: "",
      round_end_date: "",
      status: "" 
    }
  ]);
};

const updateFundingRound = (index, field, value) => {
  const updated = [...fundingRounds];
  updated[index][field] = value;

  if (field === "round_start_date" || field === "round_days") {
    const start = updated[index].round_start_date;
    const days = updated[index].round_days;
    updated[index].round_end_date = calculateEndDate(start, days);
  }

  setFundingRounds(updated);
};

const removeFundingRound = (index) => {
  setFundingRounds(fundingRounds.filter((_, i) => i !== index));
};


 const [activeCity, setActiveCity] = useState("Title");

const handleEditorChange = (content, editor) => {
  setForm((prev) => ({ ...prev, description: content }));
};

function openTab(tabName, evt, refreshFn) {
  const x = document.getElementsByClassName("city");
  for (let i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }

  const tablinks = document.getElementsByClassName("tablink");
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" w3-red", "");
  }

  const selectedCity = document.getElementById(tabName);
  if (selectedCity) selectedCity.style.display = "block";

  if (evt && evt.currentTarget)
    evt.currentTarget.className += " w3-red";

  if (refreshFn) refreshFn(tabName);
}


const [activeTabKey, setActiveTabKey] = useState({
  roadmap: 0,
  funding: 0,
  team: 0,
  entity: 0
});

function refreshTab(tabName) {
  setActiveTabKey(prev => ({
    ...prev,
    [tabName]: prev[tabName] + 1
  }));
}



  return (


    <div className="" style={{}}>
      <h5>{id ? "Edit Project" : "Add Project"}</h5>

  <div className="">
     
      <div className="w3-bar w3-black">

        <button
          type="button"
          className={`w3-bar-item w3-button w3-red tablink`}
          onClick={(e) => openTab('title',e,refreshTab)}
        >
          Title & Description
        </button>

                <button
          type="button"
          className={`w3-bar-item w3-button tablink`}
          onClick={(e) => openTab('media',e,refreshTab)}
        >
          Media
        </button>

        

    <button
          type="button"
          className={`w3-bar-item w3-button tablink`}
          onClick={(e) => openTab('entity',e,refreshTab)}
        >
          Entity
        </button>


    <button
          type="button"
          className={`w3-bar-item w3-button tablink`}
          onClick={(e) => openTab('equity',e,refreshTab)}
        >
          Equity
        </button>



   <button
          type="button"
          className={`w3-bar-item w3-button tablink`}
          
          onClick={(e) => openTab('roadmap',e,refreshTab)}
        >
        Roadmap 
        </button>

         <button
          type="button"
          className={` w3-bar-item w3-button tablink`}
          onClick={(e) => openTab('funding',e,refreshTab)}
        >
          Funding
        </button>

      </div>


 <div className="w3-container w3-border city" style={{display: ""}} id="title">
       <PfTitle  key={activeTabKey.title} onDirtyChange={(dirty) => setRoadmapDirty(dirty)} />
  </div>


<div className="w3-container w3-border city" style={{display: "none"}} id="roadmap">
     <PfRoadmap 
    key={activeTabKey.roadmap} onDirtyChange={(dirty) => setRoadmapDirty(dirty)} />
</div>



<div className="w3-container w3-border city" style={{display: "none"}} id="tags">
       <PfTags key={activeTabKey.tags} onDirtyChange={(dirty) => setRoadmapDirty(dirty)} />

</div>

<div className="w3-container w3-border city" style={{display: "none"}} id="entity">
       <PfEntity key={activeTabKey.entity} onDirtyChange={(dirty) => setRoadmapDirty(dirty)} />

</div>

<div className="w3-container w3-border city" style={{display: "none"}} id="equity">
       <PfEquity  key={activeTabKey.equity} onDirtyChange={(dirty) => setRoadmapDirty(dirty)} />
</div>

<div className="w3-container w3-border city" style={{display: "none"}} id="funding">
<PfFunding  key={activeTabKey.funding} onDirtyChange={(dirty) => setRoadmapDirty(dirty)} />
</div>

<div className="w3-container w3-border city" style={{display: "none"}} id="media">
{/* 🔹 Text Fields */}

{/* 🔹 Title Image Upload */}
        <div className="form-row w3-hide ">
          <label className="w3-small w3-text-grey">Title Image</label>
          {previews.title_image ? (
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={previews.title_image}
                alt="Title"
                style={{
                  width: "100%",
                  maxWidth: 250,
                  borderRadius: 8,
                  marginBottom: 8,
                }}
              />
              <button
                type="button"
                onClick={() => handleDeleteImage("title_image")}
                style={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  background: "#ff4d4f",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: 24,
                  height: 24,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
          ) : (
            <label
              style={{
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #aaa",
                borderRadius: 8,
                padding: 16,
                width: 150,
                height: 150,
                cursor: "pointer",
                background: "#f9f9f9",
              }}
            >
              <UploadIcon />
              <span style={{ fontSize: 12, color: "#777" }}>Upload</span>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageChange(e, "title_image")}
                style={{ display: "none" }}
              />
            </label>
          )}
        </div>

        {/* 🔹 Image Tiles */}
        <h4>Images ({imageCount}/5)</h4>
        <div
          className="images-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
            gap: 12,
          }}
        >
          {[1, 2, 3, 4, 5].map((i) => {
            const key = `image${i}`;
            return (
              <div
                key={key}
                style={{
                  background: "#fff",
                  border: "1px solid #ddd",
                  padding: 10,
                  textAlign: "center",
                  borderRadius: 8,
                  position: "relative",
                  height: 150,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {previews[key] ? (
                  <>
                    <img
                      src={previews[key]}
                      alt={`Preview ${i}`}
                      style={{
                        width: "100%",
                        height: 90,
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => handleDeleteImage(key)}
                      style={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        background: "#ff4d4f",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: 24,
                        height: 24,
                        cursor: "pointer",
                      }}
                    >
                      ×
                    </button>
                  </>
                ) : (
                  <label
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px dashed #ccc",
                      borderRadius: 8,
                      width: "100%",
                      height: 90,
                      cursor: "pointer",
                      background: "#fafafa",
                    }}
                  >
                    <UploadIcon />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, key)}
                      style={{ display: "none" }}
                    />
                  </label>
                )}
                <div style={{ fontSize: 12 }}>
                  <label>
                    <input
                      type="radio"
                      name="primary"
                      checked={form.primary_image === key}
                      onChange={() => handlePrimaryChange(key)}
                    />{" "}
                    Primary
                  </label>
                </div>
              </div>
            );
          })}
        </div>



       <hr />

        <h4>Video</h4>
        <div className="form-row">
          <label>Upload Video</label>
          <input type="file" accept="video/*" onChange={(e) => setVideoFile(e.target.files[0])} />
        </div>
        <div className="form-row">
          <label>Or Video Link</label>
          <input name="video_link" value={form.video_link} onChange={handleChange} />
        </div>
      
<div className="" style={{ marginTop: 20 }}>
  <button className="btn" type="submit" disabled={loading}>
  {loading ? "Saving..." : "Save"}
  </button>
  <button
  type="button"
  className="btn-muted"
  style={{ marginLeft: 8 }}
  onClick={() => navigate("/projects")}
  >
  Cancel
  </button>
</div>

      
</div>



<div className="w3-hide w3-padding w3-border ">
    <table className="w3-table">
    <tr>
    <td className="w3-xlarge ">
    Funding Round
    </td>
    <td> 
    <button 
    type="button" 
    onClick={addFundingRound}
    className="w3-right w3-button w3-green w3-small"
    >
    + Add Funding Round
    </button>
    </td>
    </tr>
    </table>

    {fundingRounds.map((round, index) => (

    <table key={index} className="w3-table">
    <tr>
    <td>
    {/* Round Name Dropdown */}
    <div className="form-row ">
    <label>Round Name</label>
    <select
    value={round.round_name}
    onChange={(e) => updateFundingRound(index, "round_name", e.target.value)}
    >
    <option value="">Select Round</option>
    {fundingRoundOptions.map((name) => (
    <option key={name} value={name}>{name}</option>
    ))}
    </select>
    </div>


    </td>
    <td>
    <div className="form-row">
    <label>Round Number</label>
    <input
    type="number"
    placeholder="1, 2, 3..."
    value={round.round_number}
    onChange={(e) => updateFundingRound(index, "round_number", e.target.value)}
    />
    </div>

    </td>
    <td>

    {/* Series */}
    {round.round_name === "Series" && (
    <div className="form-row ">
    <label>Series (e.g. A, B, C...)</label>
    <input
    value={round.series}
    onChange={(e) => updateFundingRound(index, "series", e.target.value)}
    placeholder="A / B / C / Seed+ etc."
    />
    </div>
    )}


    </td>
    </tr>

    <tr>
    <td>
    <div className="form-row">
    <label>Valuation</label>
    <input 
    value={round.valuation}
    onChange={(e) => updateFundingRound(index, "valuation", e.target.value)}
    />
    </div>
    </td>


    <td>
    <div className="form-row">
    <label>Amount Target</label>
    <input 
    value={round.amount_target}
    onChange={(e) => updateFundingRound(index, "amount_target", e.target.value)}
    />
    </div>

    </td>
    <td>
    <div className="form-row">
    <label>Amount Raised</label>
    <input 
    value={round.amount_raised}
    onChange={(e) => updateFundingRound(index, "amount_raised", e.target.value)}
    />
    </div>


    </td>
    </tr>

    <tr>
    <td>
    <div className="form-row">
    <label>Round Duration (Days)</label>
    <input 
    type="number"
    value={round.round_days}
    onChange={(e) => updateFundingRound(index, "round_days", e.target.value)}
    />
    </div>
    </td>
    <td>

    <div className="form-row">
    <label>Round Start Date</label>
    <input 
    type="date"
    value={round.round_start_date}
    onChange={(e) => updateFundingRound(index, "round_start_date", e.target.value)}
    />
    </div>
    </td>
    <td>


    <div className="form-row">
    <label>Round End Date (Calculated)</label>
    <input
    type="date"
    value={round.round_end_date}
    readOnly
    style={{ background: "#eee" }}
    />
    </div>


    </td>
    </tr>

    <tr>
    <td colspan="3">
    <div className="form-row">
    <label>Status</label>
    <select 
    value={round.status}
    onChange={(e) => updateFundingRound(index, "status", e.target.value)}
    >
    <option value="">Select</option>
    <option value="Open">Open</option>
    <option value="Closed">Closed</option>
    <option value="Upcoming">Upcoming</option>
    </select>
    </div>

    </td>
    </tr>


    <tr>
    <td colspan="3">

    <button 
    type="button" 
    className="w3-button w3-red w3-small"
    onClick={() => removeFundingRound(index)}
    >
    Remove Round
    </button>
    </td>
    </tr>
    </table>    
   
    ))}

</div>


    

    </div>

    </div>
  );
}
